export class LocalVpgaModel {
    id: number;
    asset_class_id: number;
    vpga: string;
}